import React, { useEffect } from 'react';
import { InputTextArea } from '@brokerbay/elements-web';
import { AccessOptionProps } from '../../types';

const Direct: React.FC<AccessOptionProps> = ({
  showingsConfig,
  setShowingsConfig,
  setIsValid,
}) => {
  useEffect(() => {
    // always valid
    setIsValid(true);
  }, [setIsValid, showingsConfig]);

  return (
    <div>
      <InputTextArea
        label="Access instructions"
        labelExtra="(optional)"
        dataCy="showing-notification-direct-instructions"
        value={showingsConfig.instructions.direct?.details || ''}
        minHeight={100}
        onChange={value =>
          setShowingsConfig(prev => ({
            ...prev,
            instructions: {
              ...prev.instructions,
              direct: {
                ...(prev.instructions.direct || {}),
                details: value,
              },
            },
          }))
        }
      />
    </div>
  );
};

export default Direct;
